import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  TributacaoCfopCadastroDto,
  TributacaoCfopCadastroImpostoDto,
  TributacaoCfopCadastroSchema,
} from "./TributacaoCfopCadastro.Dto";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  MapearErrosServidor,
  MapearErrosServidorCampo,
} from "src/hook/Functions";
import { useToast } from "src/componentes/Toast/Toast";
import {
  TributacaoCfopAtualizar,
  TributacaoCfopBuscarId,
  TributacaoCfopIncluir,
} from "src/services/Fiscal.Service";
import { IRoute } from "src/interfaces/IRoute";

const TributacaoCfopCadastroCode = () => {
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const [incluir, setIncluir] = useState(false);
  const navigate = useNavigate();
  const id = searchParams.get("id");
  const tributacaoid = searchParams.get("tributacaoid");
  const { showToast } = useToast();
  const [data, setData] = useState<
    TributacaoCfopCadastroImpostoDto[] | undefined
  >([]);
  const [menuItens, setMenuItens] = useState<IRoute[]>([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    setError,
  } = useForm<TributacaoCfopCadastroDto>({
    resolver: yupResolver(TributacaoCfopCadastroSchema),
  });

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      try {
        if (id) {
          setLoading(true);
          const response = await TributacaoCfopBuscarId(id);
          if (response.data.success) {
            const data = response.data.data;
            reset(data);
            setIncluir(false);
            setData(data.impostos);
            setMenuItens([
              {
                name: "Novo ICMS...",
                route: `/fiscal/tributacao/cfop/imposto/cadastro?type=0&tributacaocfopid=${id}`,
              },
              {
                name: "Novo IPI...",
                route: `/fiscal/tributacao/cfop/imposto/cadastro?type=1&tributacaocfopid=${id}`,
              },
            ]);
          } else {
            showToast({
              message: "Ocorreu erro ao carregar TributacaoCfop",
              title: "Erro",
              variant: "Danger",
            });
          }
        } else {
          setIncluir(true);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    Load();
    return () => {
      controller.abort();
    };
  }, [id]);

  const onSubmit = async (data: TributacaoCfopCadastroDto, e: any) => {
    e.preventDefault();
    setLoading(true);
    data.tributacaoId = Number(tributacaoid);
    data.tipoParametro = data.tipoParametro = Number(data.tipoParametro);
    data.parametroValor = Number(data.parametroValor);

    if (incluir === true) {
      TributacaoCfopIncluir(data)
        .then((response) => {
          if (response.data.success) {
            navigate(`/fiscal/tributacao/cadastro?id=${tributacaoid}`);
          } else {
            MapearErrosServidorCampo(response.data.notifications, setError);
            MapearErrosServidor(response.data.notifications, showToast);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      data.id = Number(id);
      TributacaoCfopAtualizar(data)
        .then((response) => {
          if (response.data.success) {
            navigate(`/fiscal/tributacao/cadastro?id=${tributacaoid}`);
          } else {
            MapearErrosServidorCampo(response.data.notifications, setError);
            MapearErrosServidor(response.data.notifications, showToast);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return {
    loading,
    onSubmit,
    handleSubmit,
    errors,
    register,
    setValue,
    incluir,
    data,
    menuItens,
  };
};
export default TributacaoCfopCadastroCode;
